/* eslint-disable import/prefer-default-export */
import { ILotLine } from '../../../share/types';
import { distinct } from '../../../share/utils/point';
import { getPoints } from '../../../share/utils/line';
import { round } from '../../../share/utils/round';
import { toInches } from '../../../share/utils/general';

export const buildPolygonFromLines = (lines: ILotLine[]) => distinct(lines.flatMap(getPoints));
const SUPPORT = 40;
const percentage = (x: number, percent: number) => round((x * percent) / 100);
export const getViewBoxSize = (width: number, height: number): {
  width: number;
  height: number;
  minX: number;
  minY: number;
} => (
  {
    width: toInches(width) + percentage(toInches(width), SUPPORT * 2),
    height: toInches(height) + percentage(toInches(height), SUPPORT * 2),
    // minX: 0,
    // minY: 0,
    minX: round(percentage(toInches(width), SUPPORT)),
    minY: round(percentage(toInches(height), SUPPORT)),
  }
);
